module.exports = __webpack_public_path__ + "img/share-fx.658bf3ea.png";